// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.index-module__lib-HTMLFragment--g5rYe img,
.index-module__lib-HTMLFragment--g5rYe span {
  width: 100%;
  height: 100%;
  display: inline-block;
}
`, "",{"version":3,"sources":["webpack://./src/components/HTMLFragment/index.module.less"],"names":[],"mappings":"AAEA;;EAGI,WAAA;EACA,YAAA;EACA,qBAAA;AAFJ","sourcesContent":["@import '../../assets/style/index.less';\n\n.lib-HTMLFragment {\n  // ... \n  img, span {\n    width: 100%;\n    height: 100%;\n    display: inline-block;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"lib-HTMLFragment": `index-module__lib-HTMLFragment--g5rYe`
};
module.exports = ___CSS_LOADER_EXPORT___;
